module.exports = __webpack_public_path__ + "9dbdb35f141429159d21d1bf9da3b70b.svg";